/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'cloneCustomerRunnerContractByParentRootId',
    message: messages.SUCCESS_CLONE_CUSTOMER_RUNNER_CONTRACT_BY_PARENT_ROOT_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-contract/:parentRootId/clone',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CLONE_CUSTOMER_RUNNER_CONTRACT,
    requestSchema: requestSchemas.customerRunnerContracts.cloneCustomerRunnerContractByParentRootId,
  },
  {
    action: 'createCustomerRunnerContractBySystemGameTypeId',
    message: messages.SUCCESS_CREATE_CUSTOMER_RUNNER_CONTRACT_BY_SYSTEM_GAME_TYPE_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-contract/:systemGameTypeId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_RUNNER_CONTRACT,
    requestSchema: requestSchemas.customerRunnerContracts.createCustomerRunnerContractBySystemGameTypeId,
  },
  {
    action: 'deleteCustomerRunnerContractsBySystemGameTypeId',
    message: messages.SUCCESS_DELETE_CUSTOMER_RUNNER_CONTRACTS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'DELETE',
    path: '/customer/:customerId/runner-contracts/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_RUNNER_CONTRACT,
    requestSchema: requestSchemas.customerRunnerContracts.deleteCustomerRunnerContractsBySystemGameTypeId,
  },
  {
    action: 'getCustomerRunnerContractsBySystemGameTypeId',
    message: messages.SUCCESS_GET_CUSTOMER_RUNNER_CONTRACTS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'GET',
    path: '/customer/:customerId/runner-contracts/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_RUNNER_CONTRACT,
    requestSchema: requestSchemas.customerRunnerContracts.getCustomerRunnerContractsBySystemGameTypeId,
    scopes: [
      scopes.CUSTOMER_RUNNER_CONTRACTS_INPUT_BY_SYSTEM_GAME_TYPE_ID,
      scopes.DEFAULT,
    ],
  },
  {
    action: 'updateCustomerRunnerContractById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_CONTRACT_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-contract/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_CONTRACT,
    requestSchema: requestSchemas.customerRunnerContracts.updateCustomerRunnerContractById,
  },
];
